import projectOptions from "src/shared/project-options";

const makeFetchUrl = (url?: string, params?: URLSearchParams) => {
  if (!url) return "";

  const { baseUrl } = projectOptions.default.network;
  const fetchUrl = new URL(url.includes("http") ? url : `${baseUrl}/${url}`);
  if (params) {
    fetchUrl.search = new URLSearchParams(params).toString();
  }

  return fetchUrl.toString();
};
export default makeFetchUrl;
